import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import types from '../../common/model-api/types';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import LoggerView from '../loggers/LoggerView.react';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'logger.title', 'defaultMessage': 'Logger'},
});

interface FlowLoggerProps {
    intl: IntlShape;
    relay: object;
    user: User;
}

class FlowLogger extends React.Component<FlowLoggerProps> {

    typeName = 'flows';

    constructor(props) {
        super(props);
    }

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };

    render() {
        let { user } = this.props;
        let { flow } = user.organisation;

        return (
            <AppPanel breadcrumbParams={[
                {type: types['organisations'], data: this.props.user.organisation},
                {type: types['flows'], data: this.props.user.organisation.flow}
            ]} title={this.props.intl.formatMessage(messages.title)}>
                <LoggerView logger={flow.logger} />
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(FlowLogger), (props) => {
    return props.user.organisation && props.user.organisation.flow;
}), {
    initialVariables: {
        organisationId: '',
        flowId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    name,
                    flow(id: $flowId) {
                        id,
                        organisation_id,
                        name,
                        flowDef {
                            id,
                            name,
                        },
                        logger(first: 100) {
                            ${LoggerView.getFragment('logger')}
                        }
                    }
                }
            }
        `,
    },
});
